import { memo } from 'react';
import { MediaFileProps } from './media-file.types';
import { Image, Video, Other } from './ui';
import { Wrapper } from './media-file.styled';

export const MediaFile = memo(
  ({
    file,
    view = 'cover',
    mode = 'list',
    textForOtherFile,
    videoRef,
    ...rest
  }: MediaFileProps) => (
    <Wrapper {...rest}>
      {file.type === 'image' && <Image file={file} view={view} />}

      {file.type === 'video' && (
        <Video ref={videoRef} file={file} view={view} mode={mode} />
      )}

      {file.type !== 'image' && file.type !== 'video' && (
        <Other file={file} mode={mode} textForOtherFile={textForOtherFile} />
      )}
    </Wrapper>
  )
);
